import { STATIC_OBS_URL } from '../../consts'

export interface SolutionTag {
  id: string
  name: string
  title: string
  descriptions: string
  thumbnail: string
  topic?: string
  list: {
    title: string
    discriptions: string
    thumbnail: string
    thumbnails: string[]
  }[]
}
export const solutionTags: SolutionTag[] = [
  {
    id: 'tag1',
    name: '数字装备研发',
    title: '数字装备研发',
    descriptions:
      '复杂装备和系统需要在设计研发阶段做大量的仿真支持，GCKontrol是一个功能强大、高效灵活的建模软件，支持图形化信号流建模、状态图建模，并提供丰富的白盒模型库，用户可快速搭建复杂系统的模型，不仅能够分析系统/子系统的性能，还能够优化系统结构、模型参数、控制算法等。GCAir支持多源异构模型集成、全数字化仿真和虚实融合仿真等功能，用户可以利用虚实融合仿真功能，快速验证调试模型和实物，进行系统的调整与校核，从而形成高置信度的装备模型。GCKontrol-GCAir工具链贯穿复杂装备系统全生命周期的研发过程，为装备传统研发模式向数字化、智能化转型提供工具链支撑，可实现缩短整体研发设计周期，提升研发效率的目标。',
    thumbnail: `${STATIC_OBS_URL}/website/home/solution/s1.jpeg`,
    topic: `https://static-download.globalcrown.com.cn/website/pictures/mts1drro-32e3ce75912e491a.png`,
    list: [
      {
        title: '方案应用-起落架虚实融合仿真项目',
        discriptions: `<b>1. 案例背景</b><br/>
          <p>本项目的研究目标是针对起落架系统建立集成设计与仿真、控制算法设计优化与验证的虚实融合仿真平台，实现起落架系统的全虚拟仿真、硬件在环实时仿真（HIL）以及可视化演示的功能，辅助系统工程相关研究工作。</p>
<br/>
<b>2. 案例描述</b>

          <p>本项目选用世冠科技公司的 GCAir 软件产品作为虚实融合仿真平台，选择以某型飞机转弯手轮控制律更改验证为案例，依据该任务开展数字装备虚实融合仿真试验：铁鸟人机组合试验中，由驾驶员在铁鸟座舱操纵飞机地面滑行、起飞、着陆，评估地面滑行过程中转弯手轮控制律更改优化效果。通过对铁鸟的前轮转弯系统激励器改造，开发前轮转弯系统／转弯控制单元实时模型，使铁鸟前轮转弯系统可以处于真实物理系统状态。通过GCAir实现对前轮转弯系统／控制单元的虚实切换，在滑行阶段开展手轮控制律验证，对比控制律更改前后效果。根据本案例的虚实融合试验结果，进行数字化模型的调整和综合评估，并将模型、试验数据、评估结果保存到虚实融合平台中。 </p>`,
        thumbnail: `https://static-download.globalcrown.com.cn/website/pictures/mtql1p7n-9c2f0c8f64654cbf.png`,
        thumbnails: []
      }
    ]
  },
  {
    id: 'tag2',
    name: '数字孪生运维',
    title: '数字孪生运维',
    descriptions:
      '云化GCAir 仿真平台具备GCAir 仿真引擎、工业信息数据采集交互接口、可视化编辑展示等功能于一身，内置时序数据库、AI工具箱等底座。GCAir 仿真引擎提供了数字孪生体的运行环境，支持面向实装设备完成差异化部署；工业信息数据采集交互提供孪生体和实装设备映射和信息交互的桥梁，为采用孪生体基于目前设备的运行状态进行故障预测、运行优化提供了数据来源；可视化编辑提供了多种数据展示方式，对孪生体的的运行状态提供全方位的展示。最后时序数据库实现了对历史运维数据的有效管理，AI工具箱基于历史数据和孪生体模型，为孪生体的演化和运维提供强大的助力。',
    thumbnail: `${STATIC_OBS_URL}/website/home/solution/s2.jpeg`,
    topic: `https://static-download.globalcrown.com.cn/website/pictures/mtts1ynl-c76b5f2ae98f4ced.png`,
    list: [
      {
        title: '方案应用——	飞发一体化项目',
        discriptions:
          '构建包含飞机本体及飞机发动机在内的仿真验证模型，实现对发动机性能、噪声、排放和安全性能进行评估。结合实飞数据在云端对飞机和发动机孪生体模型的飞行计划进行修正和优化，再将飞行策略反馈给实体飞机，达到通过控制策略优化油耗的目的。',
        thumbnail: `https://static-download.globalcrown.com.cn/website/pictures/mtts2mpf-c1ce503217304fad.png`,
        thumbnails: []
      },
      {
        title: '方案应用——		飞控系统虚实融合仿真平台建设项目',
        discriptions:
          '整合所内模型资源，如飞控模型、伺服模型、惯导模型、大气模型等，基于FMI标准开展标准化封装，采用GCAir集成仿真测试平台开展虚拟仿真；同时结合GCAir实时仿真系统，接入转台、负载模拟器、大气模拟器等环境设备，以及惯导、舵机、综控机等参试设备，开展虚实仿真校核试验，实现模型和实装设备的双向校验。',
        thumbnail: `https://static-download.globalcrown.com.cn/website/pictures/mtvgr9ux-8555e6298eba4194.png`,
        thumbnails: []
      }
    ]
  },
  {
    id: 'tag3',
    name: '控制系统和嵌入式软件开发',
    title: '控制系统和嵌入式软件开发',
    descriptions:
      '在系统研发过程中，通常把“系统”分解为“被控对象”和“控制系统”，这两部分交由不同的子部门研究，再进行整合，进而完成系统总体的验证。使用GCKontrol软件可完成被控对象、控制算法的建模仿真，实现模型在环(MiL)验证。GCKontrol软件支持定点计算，能够自动生成符合安全标准的C代码，用户将验证好的控制算法C代码部署至控制器-嵌入式系统，并将控制器接入GCAir仿真系统闭环回路，可完成系统的硬件在环(HiL)仿真，从而实现对系统总体和控制算法的分析研究、评估优化。对于已验证的控制算法，用户可直接用于嵌入式软件开发，使得嵌入式软件的控制算法功能更键全、种类更丰富。',
    thumbnail: `${STATIC_OBS_URL}/website/home/solution/s3.jpeg`,
    list: [
      {
        title: '方案应用——永磁直流电机(PMSM)模型，定点计算实现',
        discriptions:
          '本系统包含PMSM(永磁三相同步电机)模型和FOC(矢量控制)模型，采用GCKontrol实现PMSM电机的FOC控制，在FOC控制中用到了三个PID控制环，从内环到外环依次是：电流环(转矩控制)、速度环(转速控制)、位置环(角位移控制)。基于该控制系统实现了多种应用场景的控制策略分析，验证后的控制系统算法具有安全性、可靠性、实时性。并且该控制算法支持定点运算，可部署至控制器-嵌入式系统，使控制器在系统闭环中运行稳定可靠。',
        thumbnail: `https://static-download.globalcrown.com.cn/website/pictures/mtl3vp39-7cc57d6f78ac4dd2.png`,
        thumbnails: []
      },
      {
        title: '方案应用-卫星姿轨模型',
        discriptions:
          '卫星姿态控制系统由敏感器、控制逻辑单元（控制器）、执行和动力学模块组成。敏感器确定卫星姿态；控制器使电信号以正确顺序发送到力矩输出单元；并使卫星绕其质心转动；动力学输出再由敏感器监视，从而实现系统闭环。本案例采用GCKontrol完成卫星姿轨系统建模及控制，并对系统/子系统配置多种参数，验证了控制算法的有效性、实时性、可靠性。',
        thumbnail: `https://static-download.globalcrown.com.cn/website/pictures/mtl3vmbv-6813d351f1334de7.png`,
        thumbnails: []
      },
      {
        title: '方案应用-汽车控制应用层开发',
        discriptions:
          '本系统以新能源汽车为研究对象，用GCKontrol搭建系统模型。该系统包括驾驶员(Driver)、整车控制器(VCU)、汽车电子稳定控制系统(ESC)、发动机阻力矩控制系统(EDC)和车辆纵向动力学模型(Vehicle)等，对系统建模、配置定点计算、完成系统仿真，实现对VCU控制算法的验证评估和优化。对优化好的VCU控制算法，生成C代码，部署至真实控制器-嵌入式系统，支持并实现了嵌入式软件的开发。',
        thumbnail: `https://static-download.globalcrown.com.cn/website/pictures/mtl3vjjm-92ef54c662544436.png`,
        thumbnails: []
      }
    ]
  },
  {
    id: 'tag4',
    name: '半实物仿真/HIL-全面工具链',
    title: '半实物仿真/HIL-全面工具链',
    descriptions:
      '用GCAir可实现多源异构模型集成，并完成半实物系统的仿真测试和验证。搭建系统，将FMU导入可完成模型在环(MiL)仿真，其中FMU由GCKontrol或其他仿真软件生成；用GCAir ICD总线管理工具可定义多种总线，如CAN、1553B、A429、串口、EtherCAT、AIO/DIO等，基于这些总线可以实现GCAir实时仿真机与外围设备的通信，如参试设备、激励设备、控制器等，从而完成复杂系统的半实物(HiL)仿真、分布式仿真。把GCAir工程导入TestManager自动化测试管理工具，并配置测试大纲，测试用例，可实现系统的自动化批量测试，并自动生成测试报告。',
    thumbnail: `${STATIC_OBS_URL}/website/home/solution/s4.jpeg`,
    list: [
      {
        title: '方案应用-汽车整车控制器VCU硬件在环(HiL)仿真测试和验证',
        discriptions:
          '本案例实现新能源整车控制器VCU的硬件在环仿真测试和验证。搭建GCAir工程：1.车辆子系统做为被控对象、其FMU由GCKontrol生成；2.VCU子系统做为控制器，其嵌入式系统C代码由GCKontrol的VCU模块生成；3.配置总线报文及收发矩阵，建立被控对象与VCU的通信；4.一键虚实切换，完成VCU硬件在环（HiL）仿真测试和验证。用TestManager自动化测试工具，完成多种工况的批量自动化测试，并生成测试报告。本案例实现了控制算法的全方位评估、对控制器的可靠性全面验证。',
        thumbnail: `https://static-download.globalcrown.com.cn/website/pictures/mtkxzojf-42b8b3e5f0674a86.png`,
        thumbnails: []
      },
      {
        title: '方案应用-无人机飞行控制与管理系统适航性测试验证',
        discriptions:
          '采用GCKontrol+GCAir+TestManager全面工具链，完成了无人机试验综合管理系统，该系统硬件参测设备包括六部分：加速度转台、大气模拟器、角速度转台、卫星导航模拟器、地面站、飞控计算机。本案例完成了总体系统设计、多源异构系统集成，参测设备、激励设备硬件集成，完成了系统总体的半实物仿真，三维视景和数字孪生。并完成了自动化批量测试，自动化测试报告生成。实现了全面工具链对复杂装备系统设计研发过程的全生命周期覆盖。',
        thumbnail: `https://static-download.globalcrown.com.cn/website/pictures/mtkxxv6z-e88a8456775244ba.png`,
        thumbnails: [
          `https://static-download.globalcrown.com.cn/website/pictures/mtwv5dno-939a718ccc7e4753.png`
        ]
      }
    ]
  }
]
